import axios from 'axios'
import { OrganizationRole } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const getRoles = async (): Promise<OrganizationRole[]> => {
  const response = await api.get('/roles')
  return response.data.data
}
